import React from "react";
import { Mail, Phone, MapPin, Heart } from "lucide-react";

const Contact = ({ t }) => {
  const currentYear = new Date().getFullYear();

  if (!t) return null;

  return (
    <footer className="contact-section" id="contact">
      <div className="container">
        <div className="footer-main">
          {/* Centralni simbol */}
          <div className="heart-separator">
            <div className="line"></div>
            <Heart className="heart-icon" size={24} />
            <div className="line"></div>
          </div>

          <h2 className="script-font">{t.contactThanks}</h2>
          <p className="serif-font subtitle">{t.contactSubtitle}</p>

          <div className="contact-grid">
            {/* Kartica: Email */}
            <div className="contact-card">
              <div className="icon-wrapper">
                <Mail size={22} strokeWidth={1.2} />
              </div>
              <h4 className="serif-font">{t.contactEmailTitle}</h4>
              <a
                href="mailto:matea-reinier@wedding.com"
                className="contact-link"
              >
                matea-reinier@wedding.com
              </a>
            </div>

            {/* Kartica: Telefon */}
            <div className="contact-card">
              <div className="icon-wrapper">
                <Phone size={22} strokeWidth={1.2} />
              </div>
              <h4 className="serif-font">{t.contactPhoneTitle}</h4>
              <div className="phone-numbers">
                <p>
                  Matea: <span>+385 91 123 4567</span>
                </p>
                <p>
                  Reinier: <span>+31 6 1234 5678</span>
                </p>
              </div>
            </div>

            {/* Kartica: Lokacija */}
            <div className="contact-card">
              <div className="icon-wrapper">
                <MapPin size={22} strokeWidth={1.2} />
              </div>
              <h4 className="serif-font">{t.contactLocationTitle}</h4>
              <p className="location-name">Medvedgrad, Zagreb</p>
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="maps-btn"
              >
                {t.homeViewMap}
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="serif-font copyright">
            © {currentYear} — {t.contactCopyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Contact;
